<template>
  <div class="modal-overlay">
    <div style="border: 10px solid red; max-width: 80vw" class="mmodal-content">
      <div class="modal-header card-header text-white">
        <h5 style="color: red" class="modal-title">
          ARE YOU SURE YOU WANT TO CANCEL THIS APPOINTMENT ?
        </h5>
        <button
          style="border-color: black"
          type="button"
          class="close"
          @click="closeModal"
        >
          &times;
        </button>
      </div>
      <div class="modal-body">
        <div v-if="!loading" class="container mt-1">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="row mb-3">
                <div
                  style="
                    background-color: beige;
                    border-right: 10px solid white;
                  "
                  class="col-md-6"
                >
                  <h6 class="text-muted">Patient Name</h6>
                  <p style="color: black" class="mb-0 fw-bold">
                    {{ opd }} - {{ patient_name }}
                  </p>
                </div>
                <div style="background-color: beige" class="col-md-6">
                  <h6 class="text-muted">Appointment Date & Time</h6>
                  <p style="color: black" class="mb-0 fw-bold">
                    {{ appointment_date }}
                  </p>
                </div>
              </div>
              <div class="row mb-3">
                <div
                  style="
                    background-color: beige;
                    border-right: 10px solid white;
                  "
                  class="col-md-6"
                >
                  <h6 class="text-muted">Doctor</h6>
                  <p style="color: black" class="mb-0 fw-bold">{{ doc }}</p>
                </div>
                <div class="col-md-6">
                  <h6 class="text-muted">Department</h6>
                  <p style="color: black" class="mb-0 fw-bold">
                    {{ clinic_name }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h6 class="text-muted">Notes :</h6>
                  <p style="color: black" class="mb-0">
                    {{ note }}
                  </p>
                </div>
              </div>
            </div>
            <div class="card-footer text-end">
              <button
                @click="submitHandler"
                class="btn btn-danger"
                style="margin-right: 2em"
              >
                Proceed To Cancel
              </button>
              <button
                style="background-color: green; color: white"
                @click="closeModal"
                class="btn"
              >
                Close
              </button>
            </div>
          </div>
        </div>

        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            align-self: center;
            color: black;
            font-weight: bold;
          "
          v-if="loading"
        >
          Loading...
        </div>
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
        <button type="button" class="btn btn-primary" @click="saveModal">Save</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";

export default {
  name: "StartVisitFromAppointment",
  data() {
    return {
      loading: true,
      appointment_date: "",
      doc: "",
      note: "",
      payment_method: "",
    };
  },
  computed: {
    formattedAppointmentDate: {
      get() {
        return this.appointment_date
          ? this.appointment_date.slice(0, 16) // Removes seconds
          : "";
      },
      set(value) {
        this.appointment_date = value;
      },
    },
  },
  props: {
    appointment_id: {
      type: [Number, String],
      required: true,
    },
    patient_name: {
      type: String,
      required: true,
    },
    clinic_name: {
      type: String,
      required: true,
    },
    opd: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    saveModal() {
      this.$emit("save");
    },
    change_handler(e) {
      this[e.target.name] = e.target.value;
    },

    async submitHandler(event) {
      event.preventDefault();
      this.loading = true;
      const url = "cancel_appointment";
      const body = {
        appointment_id: this.appointment_id,
      };
      // console.log(body);

      const resp = await generalApiRequest(url, "POST", body, 1);
      if (resp) {
        this.loading = false;
        this.$emit("close");
        // this.$emit('reload-content');
        window.location.reload();
      }
    },

    async api_call() {
      const url = "get_appointment_by_id";
      const body = {
        appointment_id: this.appointment_id,
      };

      const resp = await generalApiRequest(url, "POST", body, 1);
      this.appointment_date = resp.appointment_date;
      this.doc = resp.doc;
      this.note = resp.note;
      this.loading = false;
    },
  },
  mounted() {
    this.api_call();
    console.log(this.appointment_id);
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto; /* Scrollable content */
  flex-grow: 1; /* Allow the body to grow and take available space */
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.patient-profile {
  margin: 0;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

/*  */
</style>
